import React from "react";
import { motion } from "framer-motion";

/**
 * Scroll-triggered reveal wrapper.
 * Staggers children if `stagger` prop is passed, otherwise treats children as a single block.
 */
export const Reveal = ({
    children,
    delay = 0,
    y = 24,
    duration = 0.9,
    once = true,
    className = "",
    as: Tag = "div",
    ...props
}) => {
    const MotionTag = motion[Tag] || motion.div;
    return (
        <MotionTag
            initial={{ opacity: 0, y, filter: "blur(8px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once, amount: 0.25 }}
            transition={{
                duration,
                delay,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
            {...props}
        >
            {children}
        </MotionTag>
    );
};

export const RevealStagger = ({
    children,
    className = "",
    gap = 0.08,
    initialDelay = 0,
}) => (
    <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
            visible: {
                transition: { staggerChildren: gap, delayChildren: initialDelay },
            },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export const RevealItem = ({ children, className = "", y = 24 }) => (
    <motion.div
        variants={{
            hidden: { opacity: 0, y, filter: "blur(6px)" },
            visible: {
                opacity: 1,
                y: 0,
                filter: "blur(0px)",
                transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] },
            },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export default Reveal;
